import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { ActionFromPayloadMap, Asset } from '../config/types';
import AssetReducer from '../reducers/assets';

export type AssetStateType = {
  assetsKeyedById: Map<string, Asset>
  isFetchingAssets: boolean
  isUpdatingObservation: boolean
  lastFetchFailed: boolean
  lastFetchStartTime: Date | null
  isUpdatingBulkObservation: boolean
  initialAssetFetchComplete: boolean
};

const initialState: AssetStateType = {
  assetsKeyedById: new Map(),
  isFetchingAssets: false,
  lastFetchFailed: false,
  initialAssetFetchComplete: false,
  lastFetchStartTime: null,
  isUpdatingObservation: false,
  isUpdatingBulkObservation: false,
};

export type AssetActionPayloadMap = {
  SET_ASSETS: Map<string, Asset>;
  SET_FETCHING_ASSETS: boolean;
  SET_UPDATING_OBSERVATION: boolean;
  SET_UPDATING_BULK_OBSERVATION: boolean;
  SET_LAST_FETCH_START_TIME: Date;
  SET_LAST_FETCH_ERROR: undefined;
  SET_INITIAL_FETCH_COMPLETE: undefined;
};

export type AssetAction = ActionFromPayloadMap<AssetActionPayloadMap>;

export const AssetContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<AssetAction>,
});

export const useAsset = (): [AssetStateType, React.Dispatch<AssetAction>] => {
  const { state, dispatch } = useContext(AssetContext);
  return [state, dispatch];
};

export const AssetProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(AssetReducer, initialState);

  return (
    <AssetContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </AssetContext.Provider>
  );
};
